export default interface IListIcon {
    type: IListIconType
    badge?: IListBadge
    content: string
    color: string,
    initials?: string,
    size?: number
}

export enum IListIconType {
    img = 'img',
    icon = 'icon',
    admin = 'admin',
    avatar = 'avatar',
    initials = 'initials'
}

export interface IListBadge {
    color: string
    icon?: string
    value?: string | number
    dot?: boolean
}